import React, { useEffect, useState } from 'react';
import { Home, Grid3X3, ShoppingCart, Heart, User } from 'lucide-react';
import '../assets/BottomNavigation.css';
import { useLocation } from 'react-router-dom';
import { navItems } from '../constant/bottomNav';
import { Button } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

const BottomNavigationCart = ({ translate, onNext, user, totals, totalForNotLogginUser }) => {
  const [activeTab, setActiveTab] = useState(3);
  const location = useLocation(); // گرفتن مسیر فعلی

  useEffect(() => {
    const activeItem = navItems.find((item) => item.link === location.pathname);
    if (activeItem) {
      setActiveTab(activeItem.id);
    }
  }, [location]);
  console.log({ totals });
  return (
    <nav className='bottom-nav-profile-cart'>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingInline: '5px' }}>
        <Button onClick={onNext} className='btn-success' style={{ fontSize: '14px', padding: '8px 16px', background: 'var(--main_green_dark)' }}>
          {translate('next-cart')}
        </Button>
        <div style={{ textAlign: 'left' }}>
          <span style={{ fontSize: '12px' }}> {user['is_teammate'] !== 1 ? translate('total_price') : translate('total_weight')}</span>
          <br />
          <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}>
            {Object.keys(user).length == 0 ? (
              <NumberFormat value={totalForNotLogginUser} displayType={'text'} suffix={' تومان '} thousandSeparator={true} />
            ) : user['is_teammate'] !== 1 ? (
              <NumberFormat value={totals.totalPrice} displayType={'text'} suffix={' تومان '} thousandSeparator={true} />
            ) : (
              <NumberFormat value={totals.totalWeight} suffix={' ' + translate('weight-unit') + ' '} displayType={'text'} thousandSeparator={true} />
            )}
          </span>
        </div>
      </div>
      <div className='nav-container-profile' style={{ borderTop: '1px solid #e0e0e0', marginTop: '5px' }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;

          return (
            <a key={item.id} onClick={() => setActiveTab(item.id)} className={`nav-item-profile ${isActive ? 'active-profile' : ''}`} href={item.link}>
              <Icon size={20} className={`nav-icon-profile ${isActive ? 'active-profile' : ''}`} />
              <span className={`nav-title-profile ${isActive ? 'active-profile' : ''}`}>{item.title}</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigationCart;
